import React from "react";
import { useField } from "formik";

const TextareaField = <T extends object>({
  handleClick,
  buttonType,
  label,
  error,
  required,
  ...props
}: {
  name: string;
  label?: string;
  placeholder: string;
  handleClick?: (formData?: T) => void;
  buttonType?: "button" | "reset" | "submit";
  error?: string;
  required?: boolean;
}) => {
  const [field, meta, helpers] = useField(props);

  const { value } = field;

  const { setValue } = helpers;

  const hasError = meta.touched && meta.error;

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.target;
    setValue(value);
  };

  return (
    <div className="column -row-gap10 a-textArea">
      {label && (
        <label htmlFor={label}>
          {" "}
          {label} {required && <span className="-requiredStar">*</span>}
        </label>
      )}
      <textarea
        {...props}
        className={`a-input ${hasError ? "-error" : ""}`}
        value={value}
        onChange={handleChange}
        id={label}
      />
      {hasError && <span className="a-errorMessage"> {hasError} </span>}
    </div>
  );
};

export default TextareaField;
